import { Checkbox } from '@material-ui/core';
import styled from 'styled-components';

function CategoryGroupSelector(props) {
  const { selected, categoryGroups, updateCategoryGroupSelection } = props;

  function toggleSelection(e) {
    const selectionIsOn = selected.indexOf(e.target.name) > -1;
    if (selectionIsOn) updateCategoryGroupSelection(selected.filter(field => field !== e.target.name));
    if (!selectionIsOn) updateCategoryGroupSelection([...selected, e.target.name]);
  }

  function toggleAll() {
    if (selected.length === categoryGroups.length) {
      updateCategoryGroupSelection([]);
      return;
    }

    updateCategoryGroupSelection(categoryGroups.map(group => group._id));
  }

  return (
    <Container>
      {categoryGroups?.length > 0 && categoryGroups.map((group) => (
        <CheckboxContainer key={group._id}>
          <Checkbox
            checked={selected.indexOf(group._id) > -1}
            onChange={toggleSelection}
            name={group._id}
          />
          {group.title}
        </CheckboxContainer>
      ))}
      {categoryGroups?.length > 0 && (
        <CheckboxContainer>
          <Checkbox
            checked={selected.length === categoryGroups.length}
            onChange={toggleAll}
          />
          All
        </CheckboxContainer>
      )}
    </Container>
  );
}

export default CategoryGroupSelector;

const Container = styled.div`
  background-color: white;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding-right: 24px;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;
